module.exports = __webpack_public_path__ + "static/img/Logo_Walbing.0aad1f6d.svg";